import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'button',
  ];

  /**
  * Automatically called when stimulus has initialized controller
  */
  initialize() {
    this.addEventListeners();
    this.showCurrent();
  }

  /**
   * Add event listeners to buttons
   */
  addEventListeners() {
    this.buttonTargets.forEach((button) => {
      button.addEventListener('click', (event) => {
        this.toggle(event, button)
      });
    });
  }

  /**
   * Open current tree if on subpage of aside menu
   */
  showCurrent() {
    let currentLi = this.element.querySelector('.current');
    if (currentLi) {
      while (currentLi) {
        if (currentLi.classList.contains('aside__nav-li')) {
          currentLi.closest('.aside__nav-ul').style.display = 'block';
          if (currentLi.classList.contains('hasChildren')) {
            currentLi.querySelector('.aside__nav-ul').style.display = 'block';
            currentLi.querySelector('button').classList.add('open');
          }
          currentLi = currentLi.closest('.aside__nav-ul').parentElement;
        } else {
          currentLi = null;
        }
      }
    }
  }

  /**
   * Show / hide links
   * @param {object} event Click event
   * @param {HTMLElement} button Button that was clicked
   */
  toggle(event, button) {
    event.stopPropagation();
    button.classList.toggle('open');
    let linksUl = button.closest('.aside__nav-li').querySelector('.aside__nav-ul');
    linksUl.style.display = linksUl.offsetParent === null ? 'block' : 'none';
  }
}
